export enum UsageLimitType {
	ProactiveTriggers = 'ProactiveTriggers'
}
